<template>
  <LoadCockpit />
</template>

<script>
import LoadCockpit from "../ywhc/v2/LoadCockpit.vue";

export default {
  name: "CockpitGas",
  components: {
    LoadCockpit,
  },
};
</script>
